<template>
  <div class="copy-to-cw-modal">
    <!-- 快速复制到CW对话框：选择目标起始CW/预览/确认复制 -->
  </div>
</template>

<script>
import { inject } from 'vue'

export default {
  name: 'CopyToCWModal',
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>
